import { ApiConfiguration } from "@/api/api-configuration";
import { UserCredentialAuthenticationRequest } from "@/api/models/ace/xFound/Portal/Core/CAQ/Authentication/Requests/user-credential-authentication-request";
import { AuthenticationService } from "@/api/service-index";
import { IdToken } from "@/core/models/id-token.model";
import { UserModel } from "@/core/models/user.model";
import { StateService } from "@/core/services/state.service";
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationConfig } from "../authentication.module";
import { AUTHENTICATION_CONFIG } from "../injection-tokens";
import { IdTokenRepository } from "../repositories/abstractions/id-token.repository";
import { DeleteTokenCommand, GetTokenResponse } from "../repositories/abstractions/token.repository";

@Injectable({
    providedIn: 'root',
})
export class ExtendedAuthenticationService extends AuthenticationService {

    protected _currentUser: UserModel | null;
    public get CurrentUser(): UserModel | null {
        return this._currentUser;
    }

    constructor(
        apiConfig: ApiConfiguration,
        http: HttpClient,
        protected idTokenRepository: IdTokenRepository,
        protected stateService: StateService,
        @Inject(AUTHENTICATION_CONFIG) protected authenticationConfig: AuthenticationConfig,
        protected cookieService: CookieService) {
        super(apiConfig, http);
    }

    public isAuthenticated(): boolean {
        var result: GetTokenResponse<string, IdToken> = this.getIdToken();
        var isauthenticated = false;
        if (result && result.token) {
            isauthenticated = !result.token.isExpired;
        }
        return isauthenticated;
    }

    public refreshAccessToken(): Observable<string> {
        return this.apiAuthenticationRefreshTokenPost({ body: this.authenticationConfig.scope });
    }
    
    public getIdToken(): GetTokenResponse<string, IdToken> {
        let response: GetTokenResponse<string, IdToken> = this.idTokenRepository.get();

        if(response.token && !response.token.isExpired)
            this.saveIdToken(response.token);        

        return response;
    }

    public saveIdToken(idToken: IdToken): void {        
        this.idTokenRepository.save(idToken);
        this._currentUser = new UserModel();
        this._currentUser.firstname = idToken.firstname;
        this._currentUser.lastname = idToken.lastname;
        this._currentUser.username = idToken.username;
        this._currentUser.benutzerrolle = idToken.benutzerrolle;
    }

    public deleteTokens(command: DeleteTokenCommand): void {
        this.idTokenRepository.delete(command);
    }

    public login(loginCommand: UserCredentialAuthenticationRequest): Observable<string> {
        this.stateService.clearCache();
        let domain = environment.xFoundRestUrl.replace(/^(https?:\/\/)?([^:/]+)(:\d+)?/, '$2');
        this.cookieService.delete("APP-XSRF-TOKEN", "/", domain, false, "Strict");
        this.cookieService.delete("XSRF-TOKEN", "/", domain, true, "Strict");
        return this.apiAuthenticationLoginPost(loginCommand.AsRequestBody());
    }

    public logout(): Observable<void> {
        this._currentUser = null;
        this.stateService.clearCache();
        let domain = environment.xFoundRestUrl.replace(/^(https?:\/\/)?([^:/]+)(:\d+)?/, '$2');
        return this.apiAuthenticationLogoutPost().pipe(map(response => {
            this.deleteTokens(new DeleteTokenCommand());
            this.cookieService.delete("APP-XSRF-TOKEN", "/", domain, false, "Strict");
            this.cookieService.delete("XSRF-TOKEN", "/", domain, true, "Strict");
        }));
    }
}
